import { render } from "./whatsAppConfig.vue?vue&type=template&id=70b0c7ac&scoped=true"
import script from "./whatsAppConfig.vue?vue&type=script&lang=js"
export * from "./whatsAppConfig.vue?vue&type=script&lang=js"

import "./whatsAppConfig.vue?vue&type=style&index=0&id=70b0c7ac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70b0c7ac"]])

export default __exports__